import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
@Component({
  selector: 'app-addleavepolicydetail',
  templateUrl: './addleavepolicydetail.component.html',
  styleUrls: ['./addleavepolicydetail.component.css']
})
export class AddleavepolicydetailComponent implements OnInit {


  constructor(private toastr: ToastrService, private appService: AppdataService,
    private loginService: LoginserviceService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) { }

  //Save Validation
  submitted: boolean;
  successfully: boolean;
 
  isduplicate: boolean;

  leavepolicydetailsform = new FormGroup({
    leavepolicydetid: new FormControl(0),
    leavetypeid: new FormControl(null, Validators.required),
    noofleave: new FormControl('', Validators.required),
    accurualperiod: new FormControl('', Validators.required),
    accurualperiodtype: new FormControl('', Validators.required),
    accurualperiodmonth: new FormControl(null),
    maxleaveencashdays:new FormControl(null, Validators.required),
    leaveoverflow: new FormControl(''),
    isholidaybetweenleave: new FormControl(false),
    isweekendbetweenleave: new FormControl(false),
    iscarry: new FormControl(false),
  });

  leavetypeColl: any = [];

  accurualperiodColl: any = [];
  accurualperiodtypeColl: any = [];
  accurualperiodmonthColl: any = [];

  @Input() leavepolicydetid: any = 0;
  @Input() leavetypeid: any = null;
  @Input() noofleave: any = null;
  @Input() iscarry: any = false;
  @Input() accurualperiod: any = '';
  @Input() accurualperiodtype: any = '';
  @Input() accurualperiodmonth: any = null;
  @Input() maxleaveencashdays: any = null;
  @Input() leaveoverflow: any = '';
  @Input() isholidaybetweenleave: any = false;
  @Input() isweekendbetweenleave: any = false;
  @Input() leavepolicydetailsColl: any = [];

  @Output() emitData = new EventEmitter();

  ngOnInit() {

    this.leavepolicydetailsform.reset();
    this.fnInitializeFormGroup();
    this.fngetLeavetype();
    this.fnGetAccurualPeriod();
  }


  fnInitializeFormGroup() {
    this.leavepolicydetailsform.setValue({
      leavepolicydetid: this.leavepolicydetid,
      leavetypeid: this.leavetypeid,
      noofleave: this.noofleave,      
      iscarry: this.iscarry,
      accurualperiod: this.accurualperiod,
      accurualperiodtype: this.accurualperiodtype,
      accurualperiodmonth: this.accurualperiodmonth,
      maxleaveencashdays:this.maxleaveencashdays,
      leaveoverflow:this.leaveoverflow,
      isholidaybetweenleave:this.isholidaybetweenleave,
      isweekendbetweenleave:this.isweekendbetweenleave,
    })
  }
  fngetLeavetype() {
    var data = {
      'leavetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'filterstatus': ""
    }
    this.appService.getLeaveType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.leavetypeColl = res.json().result;

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnGetAccurualPeriod() {
    this.accurualperiodColl.push({ value: 'MONTHLY', displayname: 'Monthly' });
    this.accurualperiodColl.push({ value: 'YEARLY', displayname: 'Yearly' });

    this.accurualperiodtypeColl.push({ value: 'BEGINING', displayname: 'Begining' });
    this.accurualperiodtypeColl.push({ value: 'ENDING', displayname: 'Ending' });

    this.accurualperiodmonthColl.push({ value: 1, displayname: 'Jan' });
    this.accurualperiodmonthColl.push({ value: 2, displayname: 'Feb' });
    this.accurualperiodmonthColl.push({ value: 3, displayname: 'Mar' });
    this.accurualperiodmonthColl.push({ value: 4, displayname: 'Apr' });
    this.accurualperiodmonthColl.push({ value: 5, displayname: 'May' });
    this.accurualperiodmonthColl.push({ value: 6, displayname: 'Jun' });
    this.accurualperiodmonthColl.push({ value: 7, displayname: 'Jul' });
    this.accurualperiodmonthColl.push({ value: 8, displayname: 'Aug' });
    this.accurualperiodmonthColl.push({ value: 9, displayname: 'Sep' });
    this.accurualperiodmonthColl.push({ value: 10, displayname: 'Oct' });
    this.accurualperiodmonthColl.push({ value: 11, displayname: 'Nov' });
    this.accurualperiodmonthColl.push({ value: 12, displayname: 'Dec' });


  }

  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.leavepolicydetailsform.valid) {

        var _leavetype = "";
        for (let row of this.leavetypeColl) {
          if (row.leavetypeid === this.leavepolicydetailsform.get('leavetypeid').value) {
            _leavetype = row.leavetype;
          }
        }
        for(let row of this.leavepolicydetailsColl){
          if(row.leavetypeid === this.leavepolicydetailsform.get('leavetypeid').value && this.leavetypeid !== this.leavepolicydetailsform.get('leavetypeid').value){
            this.isduplicate = true;
            return;
          }
        }
        

        //Check
        var data = {
          leavepolicydetid: this.leavepolicydetid,
          leavetypeid: this.leavepolicydetailsform.get('leavetypeid').value,
          noofleave: this.leavepolicydetailsform.get('noofleave').value,
          leavetype: _leavetype,
          iscarry: this.leavepolicydetailsform.get('iscarry').value,
          accurualperiod: this.leavepolicydetailsform.get('accurualperiod').value,
          accurualperiodtype: this.leavepolicydetailsform.get('accurualperiodtype').value,
          accurualperiodmonth: this.leavepolicydetailsform.get('accurualperiodmonth').value,
          maxleaveencashdays:this.leavepolicydetailsform.get('maxleaveencashdays').value,
          leaveoverflow:this.leavepolicydetailsform.get('leaveoverflow').value,
          isholidaybetweenleave:this.leavepolicydetailsform.get('isholidaybetweenleave').value,
          isweekendbetweenleave:this.leavepolicydetailsform.get('isweekendbetweenleave').value,       

        }



        this.emitData.emit(data);
        this.activeModal.close(true);


      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

}
